<template>
  <div class="max-w-[1300px] mx-[20px] md:mx-auto bg-GRIS_LEON rounded-lg flex justify-center">
    <div class="flex items-center justify-center gap-5 w-full max-w-[1000px]">
      <div class="relative hidden w-1/5 md:flex h-full">
        <img src="/img/newhome/newsletter/leon-newsletter.webp" alt="" class="absolute bottom-0 right-0" loading="lazy" decoding="async" />
      </div>
      <div class="w-4/5 flex-col md:p-5 flex">
        <div class="relative">
          <h3 class="text-white md:text-xl font-bold py-5 md:py-0 w-2/3">Suscríbete a nuestro Newsletter</h3>
          <img src="/img/newhome/newsletter/leon-newsletter.webp" alt="" class="block md:hidden absolute bottom-0 right-0 h-[130px]" loading="lazy" decoding="async" />
        </div>
        <form class="relative flex flex-col gap-3 mb-3" @submit.prevent="handleNewsletter">
          <input type="email" placeholder="Ingresa tu email" v-model="email" class="w-full rounded-lg p-3" />
          <button type="submit" class="bg-ROJO_LEON text-white font-semibold rounded-lg px-4 py-2 md:absolute md:right-2 md:top-1/2 md:-translate-y-1/2 md:min-w-[150px] flex items-center justify-center gap-3">
            Suscribirme
            <img src="/img/newhome/newsletter/mail.webp" alt="newsletter" loading="lazy" decoding="async" />
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref } from 'vue';
  const email = ref('');

  const handleNewsletter = ()=>{
    //console.log(email.value);
  }

</script>

<style scoped>
</style>
